import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect } from '@wp-g2/context';
import React from 'react';
import { createAnimated } from './Animated.utils';
import { useAnimated } from './useAnimated';

function Animated(props, forwardedRef) {
  var _useAnimated = useAnimated(props),
      as = _useAnimated.as,
      children = _useAnimated.children,
      otherProps = _objectWithoutProperties(_useAnimated, ["as", "children"]);

  var tagName = typeof as === 'string' ? as : 'div';
  var Component = createAnimated(tagName);
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, otherProps, {
    ref: forwardedRef
  }), children);
}

export default contextConnect(Animated, 'Animated');